<template>
  <div v-if="element.type == 'Narrative trigger'" class="mt-4">
    <h1 class="text-gray-500 text-md mb-2">
      A narrative trigger let's something new happen in your narrative — a new
      background, a new image, or new text.
    </h1>
  </div>
</template>

<script>
// import Component from "../component_location"

export default {
  components: {},

  props: ["element"],

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
